import { render, staticRenderFns } from "./CreateAddress.vue?vue&type=template&id=7a2145f2&"
import script from "./CreateAddress.vue?vue&type=script&lang=js&"
export * from "./CreateAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports